import { useState } from "react";
import { useFormContext } from "react-hook-form";

const useParticipants = () => {
    const steps = [
        {
            label: "Select organization",
            step: "organization",
        },
        {
            label: "Select brand",
            step: "brand",
        },
        {
            label: "Select products",
            step: "product",
        },
    ];

    const { setValue, watch, trigger, resetField } = useFormContext();

    const organizationId = watch("selectedOrganizationId");
    const brandId = watch("selectedBrandId");

    const [activeStep, setActiveStep] = useState(0);

    const handleNext = async () => {
        if (activeStep === 0) {
            await trigger("selectedOrganizationId");
        } else if (activeStep === 1) {
            await trigger("selectedBrandId");
        } else if (activeStep === 2 && organizationId && brandId) {
            setValue("participants", {
                ...watch("participants"),
                [organizationId]: {
                    ...watch("participants")?.[organizationId],
                    [brandId]: watch("selectedProductIds"),
                },
            });
        }

        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        resetField("selectedOrganizationId");
        resetField("selectedBrandId");
    };

    const capitalizeMenuItems = (title: string) => {
        return title.substring(0, 1).toUpperCase() + title.substring(1);
    };

    return {
        capitalizeMenuItems,
        activeStep,
        handleNext,
        handleBack,
        handleReset,
        steps,
    };
};

export { useParticipants };
